import { hsaSiteConfig } from '../config/hsa/site.config';

const portalUrl = 'http://portal-paciente-healthsuite-qa.kozaca.com.ar/';

export const environment = {
  production: false,
  SECRET_KEY: 'I0%&1P&6~5Qar-04@Pl14_72-_24Rt48',
  apiUrl: 'https://api-healthsuite-qa.kozaca.com.ar/api',
  apiUrl_photo: 'https://api-healthsuite-qa.kozaca.com.ar',
  portalUrl,
  practicasUrl: 'https://www.sanatorioaliare.com/turnos-practicas/',
  siteConfig: {
    ...hsaSiteConfig,
    navigation: {
      ...hsaSiteConfig.navigation,
      portalPacienteUrl: portalUrl,
    },
  },
};
